import cn from "classnames";
import React from "react";

type ButtonColor = "primary" | "secondary" | "danger";
type ButtonSize = "sm" | "md" | "lg";

type ButtonProps = React.ComponentProps<"button"> & {
  color?: ButtonColor;
  size?: ButtonSize;
  block?: boolean;
};

const Button = ({
  color = "primary",
  size = "md",
  block,
  className,
  disabled,
  ...props
}: ButtonProps) => {
  let btnColor, btnSize;

  if (disabled) {
    btnColor = "bg-gray-400 text-white";
  } else if (color === "secondary") {
    btnColor = "bg-secondary text-white";
  } else if (color === "danger") {
    btnColor = "bg-red-700 text-white";
  } else {
    btnColor = "bg-primary text-white";
  }

  if (size === "sm") {
    btnSize = "text-sm px-4 py-1 rounded-md";
  } else if (size === "md") {
    btnSize = "text-base px-6 py-2 rounded-lg";
  } else {
    btnSize = "text-lg px-8 py-2 rounded-xl";
  }

  return (
    <button
      className={cn(
        "focus:outline-none focus:ring ring-primary ring-opacity-40 font-semibold",
        { "w-full": block },
        btnColor,
        btnSize,
        className
      )}
      disabled={disabled}
      {...props}
    />
  );
};

export default Button;
